export default __webpack_public_path__ + "static/media/photo--lg--71.a9957017.jpg";